<template>
  <v-app>
    <v-content>
      <core-toolbar  :class="windowClass" v-if="IsLoggedIn"/>
      <core-drawer v-if="IsLoggedIn"/>
      <core-view :class="windowClass"/>
      <core-footer/>
    </v-content>
       <v-snackbar
      v-model="showAlert"
      :color="alertColor"
      :timeout="3000"
       :top="'top'"
     >
      {{alertText }}
    </v-snackbar>
     <v-overlay :value="LOADING">
      <p class="text-center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <br/>
        <i>{{LOADING_TEXT}}</i>
      </p>
    </v-overlay>
  </v-app>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  name: 'App',
  components: {
  },

  data: () => ({
    page:''
  }),
  watch:{
    page(v){
      console.log(v)
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  computed:{
    PERMISSION(){
      console.log(this.$session.get('allowed_pages'))
        return this.$session.get('allowed_pages')
    },
    LOADING(){
      return this.$store.state.overlay_loading
    },
     LOADING_TEXT(){
      return this.$store.state.overlay_loading_text
    },
      showAlert: {
        get () {
          return this.$store.state.show_alert
          },
          set (val) {
            this.setAlert(val)
          }
      },
      alertText() {
        return this.$store.state.alert_text
      },
      alertColor(){
          return this.$store.state.alert_color
      },
      windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      IsLoggedIn(){
         return this.$store.state.is_logged
      }
  },
  methods: {
    ...mapMutations(['setDrawer', 'setResponsive', 'setAlert']),
      onResponsiveInverted() {
          if (window.innerWidth < 991) {
           this.setResponsive(true)
          } else {
            this.setDrawer(true)
            this.setResponsive(false)
          }
    },
  }

};
</script>
<style>

  #va-drawer, #va-toolbar {
    text-transform: capitalize !important;
     font-family: 'Montserrat', sans-serif !important;
    
  }
  .va-not-reponsive {
    padding-left: 255px;
  }
  .va-table tbody td {
    font-size: .7em !important;
  }
  .v-text-field--outlined.v-input--dense .v-label {
    font-size: 1em !important;
  }
  @media print {
    
    .va-table  thead td {
    font-size: .45em !important;
  }
   .va-table  tbody td {
    font-size: .55em !important;
    height: 10px !important;
  }
   .va-table  tfoot td {
    font-size: .45em !important;
  }
}
  .va-underline {
    border-bottom: 1px solid #F96332;
  }
  .v-select__slot, .v-text-field__slot {
      font-size: .75em !important;
  }
  .v-btn__content {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .va-right input{
    text-align: right;
  }
  .va-input {
     width: 70px !important;
     background: #efefef;
     text-align: center;
  }
.text-secondary {
  color: #19365A;
}
.text-success {
  color: #5cb860;
}
.text-error {
  color: #f55a4e;
}
.text-primary {
  color: #68BE9F;
}
.text-warning {
  color: #ffa21a;
}
.text-info {
  color: #00d3ee;
}
.text-accent {
  color: #82B1FF;
}
.text-gray {
  color: #353535;
}
.va-status {
   text-transform: capitalize !important;
}

.inner-table td {
  border-bottom: 0 !important;
  width: 50px !important;
  text-align: center;
  border-right:  1px solid #eee;
}

/* Drawer */
#va-drawer .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
#va-drawer .v-expansion-panels .v-expansion-panel {
  background: none !important;
  /* border-radius: 0 !important;
  -webkit-box-shadow:none !important; 
   box-shadow: none !important;  */
}
#va-drawer .v-expansion-panel::before {
  -webkit-box-shadow:none !important; 
   box-shadow: none !important;

}
.xlg-font {
  font-size: 4em;
  font-weight: bold;
}
.lg-font {
  font-size: 2em;
  font-weight: bold;
}
.lg-font-s {
  font-size: 2em;
}
.sm-font {
  font-size: .7em;
}
.md-font {
  font-size: .8em;
}
.print_table3  td {
  border-bottom: 1px solid #eee;
  padding: 3px;
  min-width: 40px;
  border-left: 1px solid #eee;
}
.print_table3 .inner-table  td {
  padding: 0;
}
.page-permission .v-label {
  font-size: .8em !important;
}
.borrowed_data div span, ._borrow_data span {
    width: 120px;
    display: block;
    float: left;
}
.borrowed_data div, ._borrow_data {
  padding: 4px 0;
  height: 24px;
  border-bottom: 1px solid #eee;
}
.borrowed_data div:last-child {
  border-bottom: 0;
}
</style>